import { defineMessages } from 'react-intl';

export default defineMessages({
  darkMode: 'Dark mode',
  off: 'Off',
  on: 'On',
});
